import Dialog from './DialogContainer';
export default Dialog;



// WEBPACK FOOTER //
// ./src/js/Dialogs/index.js